import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=45859282&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45859282",
  null
  
)

export default component.exports